import { LinkPaymentStatesController } from "./link-payment-states.controller";

angular
    .module("thor.online-containers.edit.link-payment-states.component", [])
    .component("linkPaymentStates", {
        bindings: {
            containerEndDate: "<",
            isSlipPaid: "<",
            lastBidAmount: "<",
            payments: "<",
            saleCurrency: "<"
        },
        controller: LinkPaymentStatesController,
        template: require("./link-payment-states.html")
    });
